// extracted by mini-css-extract-plugin
module.exports = {"FooterBrochure":"styles_FooterBrochure__LC9Vc","height":"styles_height__FKW5N"};